import { createFileRoute } from "@tanstack/react-router"
import { imagesViewStaticData } from "src/views/GeoImagesView/constants"
import { GeoImagesView } from "src/views/GeoImagesView/GeoImagesView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/images/")({
	component: GeoImagesView,
	staticData: imagesViewStaticData,
})
